import { FC } from 'react';

import { AdminBundle } from '../../../api/client';
import { formatMoney } from '../../../shared/functions/formatter';
import { Button, Card, StatusBadge } from '../../../ui';
import { adminGroupLabel, plural } from './types';

type BundleOfferCardProps = {
  bundle: AdminBundle;
  onEdit: () => void;
};

/** The compact, scannable row an existing bundle collapses to. */
const BundleOfferCard: FC<BundleOfferCardProps> = ({ bundle, onEdit }) => {
  const requirement = bundle.groups.map((group) => group.quantity + ' from ' + adminGroupLabel(group)).join(' + ');
  const eligible = bundle.groups.reduce((sum, group) => sum + group.item_count, 0);
  const saving = Math.max(0, bundle.components_total_cents - bundle.price_cents);

  return (
    <Card
      className={bundle.active ? 'discountCard discountSummaryCard' : 'discountCard discountSummaryCard discountCardRetired'}
      data-bundle-name={bundle.name}
    >
      <div className="discountBundleRow">
        <span className="discountBundleName" title={bundle.name}>
          {bundle.name}
        </span>
        <span className="discountBundleMeta" title={requirement}>
          {requirement}
        </span>
        <span className="discountBundlePrice money">{formatMoney(bundle.price_cents)}</span>
        <StatusBadge className="discountBundleStatus" tone={bundle.active ? 'success' : 'neutral'}>
          {bundle.active ? 'Active' : 'Inactive'}
        </StatusBadge>
        <Button variant="secondary" className="discountBundleEdit" onClick={onEdit}>
          Edit
        </Button>
      </div>
      <p className="discountBundleSavings">
        {plural(eligible, 'eligible item')} · Regular {formatMoney(bundle.components_total_cents)} · Customer saves {formatMoney(saving)}
      </p>
    </Card>
  );
};

export default BundleOfferCard;
